import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Footer from "../shared/Footer";
import Navbar from "../shared/Navbar";
import Sidebar from "../shared/Sidebar";
import config from "../../config";
import Swal from "sweetalert2";
import XLSX from "xlsx-js-style";
import { motion } from "framer-motion";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

// Toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function Class11Reports() {
  const navigate = useNavigate();
  const token = sessionStorage.getItem("intermediateAdminToken");

  const [loading, setLoading] = useState(false);

  // ---------- MODAL STATES ----------
  const [showDateModal, setShowDateModal] = useState(false);
  const [showStreamModal, setShowStreamModal] = useState(false);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [selectedReport, setSelectedReport] = useState(null);
  const [selectedStream, setSelectedStream] = useState(null);

  useEffect(() => {
    if (!token) {
      navigate("/intermedate-admin");
    }
  }, []);

  const reportOptions = [
    {
      label: "Rejected by Accounts",
      url: `${config.API_BASE_URL2}/AdminGetFORejectedReport_CL12`,
      method: "GET",
      dataPath: `data["rejectedReport_list"]`,
      buttonClass: "btn-danger",
    },
    {
      label: "Approved by Accounts",
      url: `${config.API_BASE_URL2}/AdminGetFOApprovedReport_CL12`,
      method: "GET",
      dataPath: `data["approvedReport_list"]`,
      buttonClass: "btn-success",
    },
    {
      label: "Pending at Accounts",
      url: `${config.API_BASE_URL2}/AdminGetFOPendingReport_CL12`,
      method: "GET",
      dataPath: `data["pendingReport_list"]`,
      buttonClass: "btn-primary",
    },
    {
      label: "Payment not Done",
      url: `${config.API_BASE_URL2}/AdminFOChlnPendingForSubReport_CL12`,
      method: "GET",
      dataPath: `data["challanPendingForSubReport_list"]`,
      buttonClass: "btn-info",
    },
    {
      label: "All Challan",
      url: `${config.API_BASE_URL2}/AdminGetAllChallanReport_CL12`,
      method: "GET",
      dataPath: `data["allChallanReport_list"]`,
      buttonClass: "btn-warning",
    },
    {
      label: "Challan Not Generated",
      url: `${config.API_BASE_URL2}/AdminChallanNotGenerateReport_CL12`,
      method: "GET",
      dataPath: `data["adminChallanNotGenerateReport_list"]`,
      buttonClass: "btn-secondary",
    },
    {
      label: "District wise Student Count",
      url: `${config.API_BASE_URL2}/DistWiseStudentCountReport_CL12`,
      method: "POST",
      dataPath: `data["reportDistCount_list"]`,
      buttonClass: "btn-dark",
    },
    {
      label: "District wise school wise student count",
      url: `${config.API_BASE_URL2}/AdminDistrictSchoolCount_CL12NEW`,
      method: "POST",
      dataPath: `data["adminDistrict_list"]`,
      buttonClass: "btn-success",
    },
  ];
  const reportOptions2 = [
    // {
    //   label: "More Than One Vocational Subject Report",
    //   url: `${config.API_BASE_URL2}/ReportVocationalSubjectCandidatesListCL12`,
    //   method: "GET",
    //   dataPath: `data["reportVocationalSubjectCandidates_list"]`,
    //   buttonClass: "btn-danger",
    //   headers: [
    //     "Sl. No.",
    //     "District",
    //     "Name of the School",
    //     "School Code (UDISE)",
    //     "Head / Co-ordinating Person",
    //     "Contact No",
    //     "Email-ID",
    //     "Name of Candidate",
    //     "Class / Standard",
    //     "Gender (M/F)",
    //     "Date of Birth (DD-MM-YYYY)	",
    //     "Student ID 1 (AADHAAR)	",
    //     "Student ID 2 (Registration No)",
    //     "Father's Name",
    //     "Category (Gen/OBC/SC/ST)",
    //     "VOCATIONAL_SUBJECT_CODE",
    //     "Job Role",
    //     "Assessment to be conducted on curriculum, pertaining to Level",
    //     "Date of Assessment",
    //   ],
    // },

    {
      label: "Practical Subject QP Count Report",
      url: `${config.API_BASE_URL2}/PreQPCountAllCentreWiseCL12`,
      method: "POST",
      dataPath: `data["preQPCountCentreWiseAll_list"]`,
      buttonClass: "btn-primary",
      headers: [
        "SL. NO.",
        "CENTRE CODE",
        "NO. OF SCHOOLS",
        "ITS",
        "MKO",
        "MAE",
        "ECO",
        "FEN",
        "GEO",
        "ENG",
        "SOC",
        "PPG",
        "HNB",
        "AGV",
        "MNA",
        "ENA",
        "MUN",
        "MET",
        "HO",
        "PSY",
        "EAH",
        "NAG",
        "MHO",
        "STL",
        "KHA",
        "HIN",
        "PHL",
        "URD",
        "HBC",
        "POL",
        "HNA",
        "KUX",
        "KHO",
        "HSC",
        "TAH",
        "ANT",
        "ATO",
        "BAW",
        "AMH",
        "RET",
        "STA",
        "SNK",
        "MST",
        "BEN",
        "MOR",
        "MKK",
        "MUR",
        "MAT",
        "PER",
        "MMU",
        "MKU",
        "HIS",
        "KUR",
        "HEL",
        "MUS",
        "MBE",
        "ARB",
        "ORY",
      ],
    },
    {
      label: "Centre Wise QP Count Report",
      url: `${config.API_BASE_URL2}/PreClass12QPCountCentreWiseAll`,
      method: "POST",
      dataPath: `data["preClass12QPCountCentreWiseAll_list"]`,
      buttonClass: "btn-warning",
      headers: [
        "SL. NO.",
        "ROLL CODE",
        "CANDIDATE NAME",
        "MOTHER NAME",
        "FATHER NAME",
        "REGISTRATION NO",
        "DOB",
        "APPEARING",
        "LANGUAGE 1",
        "LANGUAGE 2",
        "COMPULSORY 1",
        "COMPULSORY 2",
        "COMPULSORY 3",
        "ADDITIONAL",
        "STUDENT ID",
      ],
    },

    {
      label: "Centre School Tagging Report",
      url: (selectedStream) =>
        selectedStream === "ARTS"
          ? `${config.API_BASE_URL2}/ReportDistrictCentreWiseTaggedSchoolStudentCountArts`
          : selectedStream === "SCIENCE"
            ? `${config.API_BASE_URL2}/ReportDistrictCentreWiseTaggedSchoolStudentCountScience`
            : selectedStream === "COMMERCE"
              ? `${config.API_BASE_URL2}/ReportDistrictCentreWiseTaggedSchoolStudentCountCommerce`
              : "",

      method: "GET",
      dataPath: (selectedStream) =>
        selectedStream === "ARTS"
          ? 'data["reportTaggedSchoolStudentCountArts_list"]'
          : selectedStream === "SCIENCE"
            ? 'data["reportTaggedSchoolStudentCountScience_list"]'
            : selectedStream === "COMMERCE"
              ? 'data["reportTaggedSchoolStudentCountCommerce_list"]'
              : 'data[""]',

      buttonClass: "btn-success",

      headers: [
"SL. NO.",
        "Dist-Code",
        "District Name",
        "Cent-Code",
        "Centre Name",
        "Centre Strength",
        "Tagged Sch-Code",
        "Tagged School Name",
        "No. of Student in Tagged School",
      ],
    },
    {
      label: "Faculty Wise School wise candidate Count Report",
      url: `${config.API_BASE_URL2}/ReportDistrictSchoolWiseFacultyCandidatesCountClassXII`,
      method: "GET",
      dataPath: `data["reportFacultyCandidatesCountClassXII_list"]`,
      buttonClass: "btn-info",
      headers: [
        "SL. NO.",
        "DIST. CODE",
        "DISTRICT NAME",
        "CENTRE CODE",
        "CENTRE NAME",
        "No of student in Arts",
        "No of student in Commerce",
        "No of student in Science",
        "Total Count",
      ],
    },
    {
      label: "Faculty Wise Centre Wise Candidate Count Report",
      url: `${config.API_BASE_URL2}/ReportSchoolFacultyWiseCandidatesCountClassXII`,
      method: "GET",
      dataPath: `data["reportSchoolFacultyWiseCandidatesCount_list"]`,
      buttonClass: "btn-secondary",
      headers: [
        "SL. NO.",
        "SCHOOL_CODE",
        "SCHOOL_NAME",
        "SCIENCE_COUNT",
        "ARTS_COUNT",
        "COMMERCE_COUNT",
        "TOTAL_COUNT",
      ],
    },
    // {
    //   label: "Vocational Subject Selection Report",
    //   url: `${config.API_BASE_URL2}/ReportVocationalSubjectCandidatesListCL12`,
    //   method: "GET",
    //   dataPath: `data["reportVocationalSubjectCandidates_list"]`,
    //   buttonClass: "btn-dark",
    //   headers: [
    //     "SL. NO.",
    //     "DISTRICT",
    //     "SCHOOL NAME",
    //     "UDISE CODE",
    //     "HEAD NAME",
    //     "CONTACT NO.",
    //     "EMAIL ID",
    //     "CANDIDATE NAME",
    //     "CLASS STANDARD",
    //     "GENDER",
    //     "DATE OF BIRTH",
    //     "STUDENT ID 1",
    //     "STUDENT ID 2",
    //     "FATHER NAME",
    //     "CATEGORY",
    //     "VOCATIONAL SUBJECT CODE",
    //     "JOB ROLE",
    //     "ASSESSMENT LEVEL",
    //     "DATE OF ASSESSMENT",
    //     "ASSESSOR NAME",
    //     "ASSESSOR CONTACT NUMBER",
    //     "ASSESSOR EMAIL ID",
    //   ],
    // },
 {
      label: "Vocational Subject Selection Report",
      url: `${config.API_BASE_URL2}/ReportVocationalSubjectCandidatesListCL12`,
      method: "GET",
      buttonClass: "btn-dark",
      isS3Download: true, // Direct server download for heavy 60k dataset
    },
    {
      label: "Finance Report",
      url: `${config.API_BASE_URL2}/ReportFinanceCL12`,
      method: "GET",
      dataPath: `data["reportFinanceCL12_list"]`,
      buttonClass: "btn-success",
      headers: [
        "SL. NO.",
        "DIST. CODE",
        "SCHOOL CODE",
        "SCHOOL NAME",
        "REGULAR GIRLS",
        "REGULAR BOYS (GENERAL/EWS)",
        "REGULAR BOYS (PERMANENT SC/ST/BC1/BC2)",
        "REGULAR BOYS (NON-PERMANENT SC/ST/BC1/BC2)",
        "PRIVATE GIRLS/BOYS",
        "EX-CANDIDATES (GIRLS/BOYS) - 1ST ATTEMPT",
        "EX-CANDIDATES (GIRLS/BOYS) - 2ND ATTEMPT",
        "NO. OF QUALIFIED CANDIDATES (GIRLS/BOYS) 2021-23",
        "NO. OF QUALIFIED CANDIDATES (GIRLS/BOYS) 2022-24",
        "NO. OF QUALIFIED CANDIDATES (GIRLS/BOYS) 2023-25",
        "NO. OF IMPROVEMENT CANDIDATES (GIRLS/BOYS) 2021-23",
        "NO. OF IMPROVEMENT CANDIDATES (GIRLS/BOYS) 2022-24",
        "NO. OF IMPROVEMENT CANDIDATES (GIRLS/BOYS) 2023-25",
        "TOTAL CANDIDATES",
        "ODPPM FEES (120)",
        "EXAM FEES (300/600)",
        "LOCAL LEVY (300)",
        "MARK SHEET / FORM / CERTIFICATE / TEST FEE (320)",
        "PROVISIONAL FEES (120/600)",
        "MIGRATION FEES (120)",
        "MISC. EXPENSES (120)",
        "RE-REGISTRATION FEES (300)",
        "LATE FINE (500)",
        "TOTAL FEES",
        "CHALLAN NO.",
        "JOURNAL NUMBER",
        "PAYMENT DATE",
      ],
    },
  ];

  // ---------------- FETCH WITHOUT DATE --------------------
  const fetchReportData = async (reportLabel) => {
    const reportConfig = reportOptions.find((r) => r.label === reportLabel);
    if (!reportConfig) {
      Swal.fire("Invalid report type.", "", "error");
      return;
    }

    if (reportLabel === "District wise school wise student count") {
      setSelectedReport(reportConfig);
      setShowDateModal(true);
      return;
    }
    if (reportLabel === "District wise Student Count") {
      setSelectedReport(reportConfig);
      setShowDateModal(true);
      return;
    }
    if (!token) {
      Swal.fire("Auth Error", "Token is missing. Please login.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await fetch(reportConfig.url, {
        method: reportConfig.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      const result = await response.json();
      const extractedData =
        getValueFromPath(result, reportConfig.dataPath) || [];

      if (!extractedData.length) {
        Swal.fire("No data found.", "", "info");
        return;
      }

      generateExcel(extractedData, reportConfig.label);
    } catch {
      Swal.fire("Error", "Error fetching report.", "error");
    } finally {
      setLoading(false);
    }
  };

  // const fetchReportData2 = async (reportLabel, stream) => {
  //   const reportConfig = reportOptions2.find((r) => r.label === reportLabel);
  //   if (!reportConfig) {
  //     Swal.fire("Invalid report type.", "", "error");
  //     return;
  //   }

  //   if (!token) {
  //     Swal.fire("Auth Error", "Token is missing. Please login.", "error");
  //     return;
  //   }

  //   setLoading(true);
  //   try {
  //     const response = await fetch(reportConfig.url, {
  //       method: reportConfig.method,
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "Content-Type": "application/json",
  //       },
  //       body:
  //         reportConfig.method !== "GET"
  //           ? JSON.stringify({
  //             stream: selectedStream.value,
  //           })
  //           : undefined,
  //     });

  //     const result = await response.json();
  //     const extractedData =
  //       getValueFromPath(result, reportConfig.dataPath) || [];

  //     if (!extractedData.length) {
  //       Swal.fire("No data found.", "", "info");
  //       return;
  //     }

  //     generateExcel2(extractedData, reportConfig);
  //   } catch (error) {
  //     Swal.fire("Error", "Error fetching report.", "error");
  //   } finally {
  //     setLoading(false);
  //   }
  // };
const fetchReportData2 = async (reportLabel, stream) => {
  const reportConfig = reportOptions2.find((r) => r.label === reportLabel);
  if (!reportConfig) {
    Swal.fire("Invalid report type.", "", "error");
    return;
  }

  // 1. Route S3 pre-signed downloads to dedicated handler
  if (reportConfig.isS3Download) {
    await handleS3FileDownload(reportConfig, stream);
    return;
  }

  // 2. Validate Authentication
  if (!token) {
    Swal.fire("Auth Error", "Token is missing. Please login.", "error");
    return;
  }

  // 3. Handle JSON Data Fetch + Client-side Excel Generation
  setLoading(true);
  try {
    const isPostOrPut = reportConfig.method && reportConfig.method.toUpperCase() !== "GET";
    const selectedStreamValue = stream || (typeof selectedStream !== "undefined" ? selectedStream?.value : undefined);

    const response = await fetch(reportConfig.url, {
      method: reportConfig.method || "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: isPostOrPut && selectedStreamValue ? JSON.stringify({ stream: selectedStreamValue }) : undefined,
    });

    if (!response.ok) {
      throw new Error(`Server returned ${response.status}`);
    }

    const result = await response.json();
    const extractedData = getValueFromPath(result, reportConfig.dataPath) || [];

    if (!extractedData.length) {
      Swal.fire("No data found.", "", "info");
      return;
    }

    generateExcel2(extractedData, reportConfig);
  } catch (error) {
    console.error("fetchReportData2 error:", error);
    Swal.fire("Error", "Error fetching report.", "error");
  } finally {
    setLoading(false);
  }
};

const handleS3FileDownload = async (reportConfig, stream) => {
  if (!token) {
    Swal.fire("Auth Error", "Token is missing. Please login.", "error");
    return;
  }

  setLoading(true);
  try {
    const isPostOrPut = reportConfig.method && reportConfig.method.toUpperCase() !== "GET";
    const selectedStreamValue = stream || (typeof selectedStream !== "undefined" ? selectedStream?.value : undefined);

    const response = await fetch(reportConfig.url, {
      method: reportConfig.method || "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: isPostOrPut && selectedStreamValue ? JSON.stringify({ stream: selectedStreamValue }) : undefined,
    });

    const result = await response.json();

    if (!response.ok || !result.fileUrl) {
      throw new Error(result.message || "Failed to generate report.");
    }

    // Trigger download using hidden anchor tag to prevent navigation glitches
    const link = document.createElement("a");
    link.href = result.fileUrl;
    link.setAttribute("download", "");
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    Swal.fire("Success", "Report download started.", "success");
  } catch (error) {
    console.error("handleS3FileDownload error:", error);
    Swal.fire("Error", error.message || "Error downloading report.", "error");
  } finally {
    setLoading(false);
  }
};
  // ---------------- FETCH WITH DATE (MODAL) --------------------
  const fetchReportWithDate = async () => {
    if (!fromDate || !toDate) {
      toast.error("Please select both dates!");
      return;
    }

    if (new Date(toDate) < new Date(fromDate)) {
      toast.error("To Date cannot be earlier than From Date!");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(selectedReport.url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          fromDate: fromDate,
          toDate: toDate,
        }),
      });

      const result = await response.json();
      const extractedData =
        getValueFromPath(result, selectedReport.dataPath) || [];

      if (!extractedData.length) {
        toast.error("No data found for selected date range");
        return;
      }

      generateExcel(extractedData, selectedReport.label);
      setShowDateModal(false);
    } catch {
      toast.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  };

  const fetchReportWithStream = async () => {
    if (!selectedStream?.value) {
      toast.error("Please select stream!");
      return;
    }

    setLoading(true);

    try {
      const url =
        typeof selectedReport.url === "function"
          ? selectedReport.url(selectedStream.value)
          : selectedReport.url;

      if (!url) {
        toast.error("Invalid report URL");
        return;
      }

      const options = {
        method: selectedReport.method,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      };

      if (selectedReport.label === "Centre Wise QP Count Report") {
        options.body = JSON.stringify({
          stream: selectedStream.value,
        });
      }
      if (selectedReport.label === "Practical Subject QP Count Report") {
        options.body = JSON.stringify({
          stream: selectedStream.value,
        });
      }

      const response = await fetch(url, options);

      const result = await response.json();

      const dataPath =
        typeof selectedReport.dataPath === "function"
          ? selectedReport.dataPath(selectedStream.value)
          : selectedReport.dataPath;

      const extractedData = getValueFromPath(result, dataPath) || [];

      if (!extractedData.length) {
        toast.error("No data found");
        return;
      }

      generateExcel2(extractedData, selectedReport);
      setShowStreamModal(false);
    } catch (error) {
      console.error(error);
      toast.error("Error fetching report");
    } finally {
      setLoading(false);
    }
  };

  const getValueFromPath = (obj, path) => {
    try {
      return path
        .replace(/\[(["']?)([^\[\]"']+)\1\]/g, ".$2")
        .split(".")
        .reduce((acc, key) => acc?.[key], obj);
    } catch {
      return undefined;
    }
  };

  const generateExcel = (data, report) => {
    try {
      const reportTitle = String(
        typeof report === "string" ? report : report?.label || "Report",
      );
      const isVocationalReport =
        reportTitle === "More Than One Vocational Subject Report" ||
        reportTitle === "Vocational Subject Selection Report" ||
        report?.label === "More Than One Vocational Subject Report" ||
        report?.label === "Vocational Subject Selection Report";

      const dataKeys = Object.keys(data[0] || {});
      const formattedHeaders = Array.isArray(report?.headers)
        ? report.headers
        : ["SL. NO.", ...dataKeys.map((k) => k.toUpperCase())];

      if (isVocationalReport) {
        const now = new Date();
        const dateStr = `${String(now.getDate()).padStart(2, "0")}-${String(
          now.getMonth() + 1,
        ).padStart(2, "0")}-${now.getFullYear()} ${now
          .toLocaleTimeString("en-GB")
          .toUpperCase()}`;

        const ws = XLSX.utils.aoa_to_sheet([
          [`Report: ${reportTitle}`],
          [`Generated on: ${dateStr}`],
          [],
          formattedHeaders,
        ]);

        const rows = data.map((item, i) => [
          i + 1,
          ...dataKeys.map((key) => item[key] ?? ""),
        ]);

        XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

        ws["!merges"] = [
          { s: { r: 0, c: 0 }, e: { r: 0, c: formattedHeaders.length - 1 } },
        ];

        ws["!cols"] = formattedHeaders.map(() => ({ wch: 20 }));

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report");

        const safeFileName = `Report_Intermediate_${reportTitle.replace(
          /[^a-zA-Z0-9]/g,
          "_",
        )}.xlsx`;
        XLSX.writeFile(wb, safeFileName);

        Swal.fire("Success", "Excel file downloaded", "success");
        return;
      }

      const ws = XLSX.utils.aoa_to_sheet([formattedHeaders]);

      const rows = data.map((item, i) => [
        i + 1,
        ...dataKeys.map((key) => item[key] ?? ""),
      ]);

      const hasGrandTotal =
        report?.hasGrandTotal ||
        reportTitle.includes("Count Report") ||
        reportTitle.includes("QP Count");

      if (hasGrandTotal && data.length > 0) {
        const secondKeyVal =
          dataKeys.length > 1
            ? data.find(
              (d) => d[dataKeys[1]] !== null && d[dataKeys[1]] !== undefined,
            )?.[dataKeys[1]]
            : null;
        const isSecondKeyString =
          typeof secondKeyVal === "string" && isNaN(Number(secondKeyVal));

        const totalRow = [
          "", // SL. NO.
          ...dataKeys.map((key, kIndex) => {
            if (isSecondKeyString && kIndex === 1) {
              return "GRAND TOTAL";
            }
            if (isSecondKeyString && kIndex < 1) {
              return "";
            }
            if (!isSecondKeyString && kIndex === 0) {
              return "GRAND TOTAL";
            }

            const firstVal = data.find(
              (d) => d[key] !== null && d[key] !== undefined,
            )?.[key];
            const isNumeric =
              typeof firstVal === "number" ||
              (typeof firstVal === "string" &&
                !isNaN(Number(firstVal)) &&
                firstVal.trim() !== "");

            if (isNumeric) {
              return data.reduce(
                (sum, item) => sum + (Number(item[key]) || 0),
                0,
              );
            }
            return "";
          }),
        ];
        rows.push(totalRow);
      }

      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!cols"] = formattedHeaders.map(() => ({ wch: 20 }));

      // Format cells: Headers bold & center aligned, data center aligned only, Grand Total row bold & center aligned
      const range = XLSX.utils.decode_range(ws["!ref"] || "A1");
      const lastRowIndex = range.e.r;

      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellAddress]) continue;

          if (R === 0) {
            // Header row: bold & center aligned
            ws[cellAddress].s = {
              font: { bold: true },
              alignment: { horizontal: "center", vertical: "center", wrapText: true },
            };
          } else if (hasGrandTotal && R === lastRowIndex) {
            // Grand Total row: bold & center aligned
            ws[cellAddress].s = {
              font: { bold: true },
              alignment: { horizontal: "center", vertical: "center" },
            };
          } else {
            // Data rows: center align only
            ws[cellAddress].s = {
              alignment: { horizontal: "center", vertical: "center" },
            };
          }
        }
      }

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");

      const safeTitle = String(reportTitle || "Report");
      const safeFileName = `Report_Intermediate_${safeTitle.replace(
        /[^a-zA-Z0-9]/g,
        "_",
      )}.xlsx`;

      XLSX.writeFile(wb, safeFileName);

      Swal.fire("Success", "Excel file downloaded", "success");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to generate Excel", "error");
    }
  };

  const generateExcel2 = (data, report) => {
    try {
      if (!data || data.length === 0) {
        Swal.fire("Info", "No data available", "info");
        return;
      }

      const reportLabel = String(
        typeof report === "string" ? report : report?.label || "Report",
      );
      const apiKeys = Object.keys(data[0]);
      const isVocationalReport =
        reportLabel === "More Than One Vocational Subject Report" ||
        reportLabel === "Vocational Subject Selection Report" ||
        report?.label === "More Than One Vocational Subject Report" ||
        report?.label === "Vocational Subject Selection Report";

       const formattedHeaders = report?.headers || [
        "SL. NO.",
        ...apiKeys.map((key) => key.toUpperCase()),
      ];

      if (isVocationalReport) {
        const now = new Date();
        const dateStr = `${String(now.getDate()).padStart(2, "0")}-${String(
          now.getMonth() + 1,
        ).padStart(2, "0")}-${now.getFullYear()} ${now
          .toLocaleTimeString("en-GB")
          .toUpperCase()}`;

        const ws = XLSX.utils.aoa_to_sheet([
          [`Report: ${reportLabel}`],
          [`Generated on: ${dateStr}`],
          [],
          formattedHeaders,
        ]);

        const rows = data.map((item, index) => [
          ...(isVocationalReport ? [] : [index + 1]),
          ...apiKeys.map((key) => item[key] ?? ""),
        ]);
        XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

        ws["!merges"] = [
          {
            s: { r: 0, c: 0 },
            e: { r: 0, c: formattedHeaders.length - 1 },
          },
        ];

        ws["!cols"] = formattedHeaders.map(() => ({ wch: 20 }));

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Report");

        const safeFileName = `Intermediate_Pre_Exam_Report_CL12_${reportLabel.replace(
          /[^a-zA-Z0-9]/g,
          "_",
        )}.xlsx`;

        XLSX.writeFile(wb, safeFileName);

        Swal.fire("Success", "Excel file downloaded", "success");
        return;
      }

      const ws = XLSX.utils.aoa_to_sheet([formattedHeaders]);

      const rows = data.map((item, index) => [
        index + 1,
        ...apiKeys.map((key) => item[key] ?? ""),
      ]);

      const hasGrandTotal =
        report?.hasGrandTotal ||
        reportLabel === "Centre Wise QP Count Report" ||
        reportLabel === "Practical Subject QP Count Report" ||
        reportLabel.includes("QP Count") ||
        reportLabel.includes("Count Report");

      if (hasGrandTotal && data.length > 0) {
        const secondKeyVal =
          apiKeys.length > 1
            ? data.find(
              (d) => d[apiKeys[1]] !== null && d[apiKeys[1]] !== undefined,
            )?.[apiKeys[1]]
            : null;
        const isSecondKeyString =
          typeof secondKeyVal === "string" && isNaN(Number(secondKeyVal));

        const totalRow = [
          "", // SL. NO.
          ...apiKeys.map((key, kIndex) => {
            if (isSecondKeyString && kIndex === 1) {
              return "GRAND TOTAL";
            }
            if (isSecondKeyString && kIndex < 1) {
              return "";
            }
            if (!isSecondKeyString && kIndex === 0) {
              return "GRAND TOTAL";
            }

            const firstVal = data.find(
              (d) => d[key] !== null && d[key] !== undefined,
            )?.[key];
            const isNumeric =
              typeof firstVal === "number" ||
              (typeof firstVal === "string" &&
                !isNaN(Number(firstVal)) &&
                firstVal.trim() !== "");

            if (isNumeric) {
              return data.reduce(
                (sum, item) => sum + (Number(item[key]) || 0),
                0,
              );
            }
            return "";
          }),
        ];
        rows.push(totalRow);
      }

      XLSX.utils.sheet_add_aoa(ws, rows, { origin: -1 });

      ws["!cols"] = formattedHeaders.map(() => ({ wch: 20 }));

      // Format cells: Headers bold & center aligned, data center aligned only, Grand Total row bold & center aligned
      const range = XLSX.utils.decode_range(ws["!ref"] || "A1");
      const lastRowIndex = range.e.r;

      for (let R = range.s.r; R <= range.e.r; ++R) {
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
          if (!ws[cellAddress]) continue;

          if (R === 0) {
            // Header row: bold & center aligned
            ws[cellAddress].s = {
              font: { bold: true },
              alignment: { horizontal: "center", vertical: "center", wrapText: true },
            };
          } else if (hasGrandTotal && R === lastRowIndex) {
            // Grand Total row: bold & center aligned
            ws[cellAddress].s = {
              font: { bold: true },
              alignment: { horizontal: "center", vertical: "center" },
            };
          } else {
            // Data rows: center align only
            ws[cellAddress].s = {
              alignment: { horizontal: "center", vertical: "center" },
            };
          }
        }
      }

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Report");

      const safeFileName = `Intermediate_Pre_Exam_Report_CL12_${reportLabel.replace(
        /[^a-zA-Z0-9]/g,
        "_",
      )}.xlsx`;

      XLSX.writeFile(wb, safeFileName);

      Swal.fire("Success", "Excel file downloaded", "success");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Failed to generate Excel", "error");
    }
  };
  const handleChangeFromDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setFromDate(`${dd}-${mm}-${yyyy}`);
    } else {
      setFromDate("");
    }
  };

  const handleChangeToDate = (date) => {
    if (date) {
      const dd = String(date.getDate()).padStart(2, "0");
      const mm = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();

      setToDate(`${dd}-${mm}-${yyyy}`);
    } else {
      setToDate("");
    }
  };

  const streamOptions = [
    { value: "", label: "Select" },
    { value: "ARTS", label: "Arts" },
    { value: "SCIENCE", label: "Science" },
    { value: "COMMERCE", label: "Commerce" },
  ];

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={2000}
        style={{ zIndex: "10001" }}
      />

      <div className="container-scroller">
        {loading && (
          <div className="custom-loader-container">
            <div className="custom-loader"></div>
          </div>
        )}

        {/* -------------------- DATE MODAL -------------------- */}
        {showDateModal && (
          <motion.div
            className="modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <motion.div
              initial={{ scale: 0.6, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="modal-content"
              style={{
                background: "#fff",
                padding: "25px",
                borderRadius: "10px",
                width: "400px",
              }}
            >
              <h4>Select Date Range</h4>

              {/* ---------------- FROM DATE ---------------- */}
              <div className="form-group mt-3">
                <label>From Date</label>
                {/* <DatePicker
                  selected={fromDate ? new Date(fromDate) : null}
                  onChange={(date) =>
                    setFromDate(date ? date.toISOString().split("T")[0] : "")
                  }
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  placeholderText="Select From Date"
                  minDate={new Date("2025-01-01")}
                  maxDate={new Date()}
                /> */}
                <DatePicker
                  minDate={new Date(2025, 10, 18)}
                  maxDate={new Date()}
                  selected={
                    fromDate
                      ? (() => {
                        const [dd, mm, yyyy] = fromDate.split("-");
                        return new Date(
                          Number(yyyy),
                          Number(mm) - 1,
                          Number(dd),
                        );
                      })()
                      : null
                  }
                  onChange={(date) => handleChangeFromDate(date)}
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  placeholderText="Select From Date"
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              {/* ---------------- TO DATE ---------------- */}
              <div className="form-group mt-3">
                <label>To Date</label>
                {/* <DatePicker
                  selected={toDate ? new Date(toDate) : null}
                  onChange={(date) =>
                    setToDate(date ? date.toISOString().split("T")[0] : "")
                  }
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  placeholderText="Select To Date"
                  minDate={
                    fromDate ? new Date(fromDate) : new Date("2025-01-01")
                  }
                  maxDate={new Date()}
                /> */}
                <DatePicker
                  minDate={
                    fromDate
                      ? (() => {
                        const [dd, mm, yyyy] = fromDate.split("-");
                        return new Date(
                          Number(yyyy),
                          Number(mm) - 1,
                          Number(dd),
                        );
                      })()
                      : new Date(2025, 0, 1)
                  }
                  maxDate={new Date()}
                  selected={
                    toDate
                      ? (() => {
                        const [dd, mm, yyyy] = toDate.split("-");
                        return new Date(
                          Number(yyyy),
                          Number(mm) - 1,
                          Number(dd),
                        );
                      })()
                      : null
                  }
                  onChange={(date) => handleChangeToDate(date)}
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  placeholderText="Select To Date"
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              <div className="mt-4 d-flex justify-content-between">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowDateModal(false);
                    setFromDate("");
                    setToDate("");
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={fetchReportWithDate}
                >
                  Download
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}

        {showStreamModal && (
          <motion.div
            className="modal-backdrop"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            style={{
              position: "fixed",
              inset: 0,
              background: "rgba(0,0,0,0.5)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <motion.div
              initial={{ scale: 0.6, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              className="modal-content"
              style={{
                background: "#fff",
                padding: "25px",
                borderRadius: "10px",
                width: "400px",
              }}
            >
              <h4>Report Filters</h4>

              {/* ---------------- FROM DATE ---------------- */}
              <div className="form-group mt-3">
                <div className="mb-3">
                  <label className="form-label fw-bold">
                    <i className="fa fa-filter me-1"></i>
                    Select Stream
                  </label>

                  <Select
                    options={streamOptions}
                    value={selectedStream}
                    onChange={setSelectedStream}
                    placeholder="Select Stream"
                  />
                </div>
              </div>

              <div className="mt-2 d-flex justify-content-between">
                <button
                  className="btn btn-secondary"
                  onClick={() => {
                    setShowStreamModal(false);
                    setSelectedStream("");
                  }}
                >
                  Cancel
                </button>

                <button
                  className="btn btn-success"
                  onClick={fetchReportWithStream}
                >
                  Download
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}

        <Navbar />
        <div className="container-fluid page-body-wrapper">
          <Sidebar />
          <div className="main-panel">
            <div className="content-wrapper">
              <section className="content-header mb-4">
                <h1>
                  <i className="fa fa-university" /> Class XII Reports
                </h1>
                <ol className="breadcrumb">
                  <li>
                    <a
                      onClick={() => navigate("/intermediate-admin-dashboard")}
                      style={{ cursor: "pointer" }}
                    >
                      <i className="fa fa-tachometer mr-2"></i> Home
                    </a>
                  </li>
                  <li className="active">
                    Intermediate Accounts Reports Class XII
                  </li>
                </ol>
              </section>

              <div className="row">
                <div className="col-md-4">
                  <div className="card">
                    <div className="card-header bg-green">
                      <h5>Class XII Reports</h5>
                    </div>
                    <div className="card-body">
                      <table className="table">
                        <tbody>
                          {reportOptions.map((report, index) => (
                            <tr key={index}>
                              <td>
                                <button
                                  className={`btn ${report.buttonClass} w-100`}
                                  style={{ textAlign: "left" }}
                                  onClick={() => fetchReportData(report.label)}
                                >
                                  <i className="fa fa-download excel-icon-rounded"></i>
                                  &nbsp;
                                  {report.label}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="card">
                    <div className="card-header bg-green">
                      <h5>Class XII Pre Exam Report</h5>
                    </div>
                    <div className="card-body">
                      <table className="table">
                        <tbody>
                          {reportOptions2.map((report, index) => (
                            <tr key={index}>
                              <td>
                                <button
                                  className={`btn ${report.buttonClass} w-100`}
                                  style={{ textAlign: "left" }}
                                  onClick={() => {
                                    if (
                                      report.label ===
                                      "Centre School Tagging Report" ||
                                      report.label ===
                                      "Centre Wise QP Count Report" ||
                                      report.label ===
                                      "Practical Subject QP Count Report"
                                    ) {
                                      setSelectedReport(report);
                                      setShowStreamModal(true);
                                    } else {
                                      fetchReportData2(report.label);
                                    }
                                  }}
                                >
                                  <i className="fa fa-download excel-icon-rounded"></i>
                                  &nbsp;
                                  {report.label}
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Footer />
          </div>
        </div>
      </div>
    </>
  );
}

export default Class11Reports;
